/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_AllInputs */

const en_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply to All`)
};

const fr_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'appliquer à tous`)
};

const de_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für alle gelten`)
};

const it_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica a tutti`)
};

const ru_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применяется ко всем`)
};

const es_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a todos`)
};

const zh_cn2_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于所有`)
};

const ja_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてに適用`)
};

const hi_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी पर लागू होते हैं`)
};

const pt_pt2_apply_to_all = /** @type {(inputs: Apply_To_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a todos`)
};

/**
* | output |
* | --- |
* | "Apply to All" |
*
* @param {Apply_To_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all = /** @type {((inputs?: Apply_To_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_to_all(inputs)
	if (locale === "de") return de_apply_to_all(inputs)
	if (locale === "it") return it_apply_to_all(inputs)
	if (locale === "ru") return ru_apply_to_all(inputs)
	if (locale === "es") return es_apply_to_all(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_to_all(inputs)
	if (locale === "ja") return ja_apply_to_all(inputs)
	if (locale === "hi") return hi_apply_to_all(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_to_all(inputs)
	return en_apply_to_all(inputs)
});